import React from "react";
import { facilityGallery } from "@/data/mock";

export default function FasilitasKamiSection() {
  const visibleGallery = Array.isArray(facilityGallery)
    ? facilityGallery.filter((x) => !x?.hidden)
    : [];

  return (
    <section id="fasilitas" className="gallery-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">Fasilitas Kami</span>
          <h2 className="section-title">
            Produksi dengan Standar
            <br />
            <span className="text-accent">Kebersihan Tinggi</span>
          </h2>
          <p className="section-description">
            Dokumentasi fasilitas dan aktivitas produksi untuk menunjukkan komitmen terhadap kebersihan dan kerapihan proses kerja.
          </p>
        </div>

        <div className="gallery-grid">
          {visibleGallery.map((item, index) => (
            <div key={index} className="gallery-item">
              <img
                src={encodeURI(item.image)}
                alt={item.title}
                className="gallery-image"
              />
              <div className="gallery-caption">
                <p style={{ fontWeight: 900 }}>{item.title}</p>
                {item.caption ? (
                  <p style={{ fontSize: 12, opacity: 0.85 }}>{item.caption}</p>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
